"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6727],{

/***/ 36727:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Inspirations; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/inspiration1.png
/* harmony default export */ var inspiration1 = ({"src":"/_next/static/media/inspiration1.1ff20063.png","height":675,"width":1200,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAARVBMVEU+NjJLQDmHgHxjVEdsa2xbVU9STkVkWFEnKSgoMzYgJCOhkod+dHQ2LyqlnZoSISQ8RkiboabJvLRYXmB2YlayopjI0NPKrqwtAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAMElEQVR4nAXBhwEAIAgDsCoo4N7/n2oCgOfzmyHB8cpmaN6dG7SjRKU8yICaRDSmDx59AVy9+tLYAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/inspiration2.png
/* harmony default export */ var inspiration2 = ({"src":"/_next/static/media/inspiration2.ccd72475.png","height":675,"width":1200,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAS1BMVEVQPjC5oYqjiolcWVp+bWd2bnJvYlpYTUqGfXtjVEdENy55Zk1bTkSdh3KWXzmVeHKkmJOceUZ3VjRMLR3LrrCxfGW7sLfLl43m4+n2whr3AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAMUlEQVR4nAXBiQHAEBAAwfUegsSf/is1g4eiPuewMT+t6p8QYl/zaBAZ77YGkgjeqAsgpgFobUYmqAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/inspiration3.png
/* harmony default export */ var inspiration3 = ({"src":"/_next/static/media/inspiration3.27a9e232.png","height":675,"width":1200,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAPFBMVEVsXk59dG5TOziakYVhU0KdinluZFRvZl1kVlNVRDI8MimHb1hQSkVrWUV5c22IdlGAd1dUXWm1o4Xd0LWXCP/2AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAL0lEQVR4nAXBhwEAIAjAsKoo4B7//2qC95BVrSGjrHKikaboRo2AkJpVYnXP7/IBGnEBLG7tdIkAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});
// EXTERNAL MODULE: ./src/qualification/hooks/useBreakpoints.ts
var useBreakpoints = __webpack_require__(19916);
;// CONCATENATED MODULE: ./src/static_pages/home/variationB/components/Inspirations.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: ",
        "px !important;\n  max-width: 351px;\n  img {\n    border-radius: ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 47px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 30.24px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  line-height: 26.88px;\n  font-weight: 400;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: ",
        "px;\n  width: min-content;\n  font-size: 14px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 1118px;\n  margin: auto;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 36px;\n  line-height: 62.1px;\n  font-weight: 700;\n  text-align: center;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  line-height: 26.88px;\n  font-weight: 400;\n  text-align: center;\n  margin-top: ",
        "px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}










function Inspirations() {
    var t = (0,useTranslation/* useTranslation */.$)("homepage").t;
    var mobile = (0,useBreakpoints/* useBreakpointDown */.a)("sm");
    if (mobile) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                children: t("inspirations.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                children: t("inspirations.subtitle")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                my: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                    display: "flex",
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {
                            image: inspiration1,
                            title: t("inspirations.card1.title"),
                            body: t("inspirations.card1.body"),
                            ctaText: t("inspirations.card1.cta"),
                            link: "https://www.heycater.com/de/hub/hey-wissen/firmenevent-planen"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {
                            image: inspiration2,
                            title: t("inspirations.card2.title"),
                            body: t("inspirations.card2.body"),
                            ctaText: t("inspirations.card2.cta"),
                            link: "https://www.heycater.com/de/hub/hey-wiki/flying-buffet"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {
                            image: inspiration3,
                            title: t("inspirations.card3.title"),
                            body: t("inspirations.card3.body"),
                            ctaText: t("inspirations.card3.cta"),
                            link: "https://www.heycater.com/de/hub/hey-wiki/was-ist-catering-eine-definition"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                display: "flex",
                justifyContent: "center",
                mt: 6,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "https://www.heycater.com/de/hub/hey-community",
                    target: "_blank",
                    rel: "noreferrer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CTAButton, {
                        variant: "secondary",
                        children: t("inspirations.cta")
                    })
                })
            })
        ]
    });
}
function Card(param) {
    var image = param.image, title = param.title, body = param.body, ctaText = param.ctaText, link = param.link;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                alt: "",
                src: image,
                height: 212,
                width: 351
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Body, {
                children: body
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: link || "",
                target: "_blank",
                rel: "noreferrer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                    variant: "tertiary",
                    children: ctaText
                })
            })
        ]
    });
}
var CardWrapper = styled_components_browser_esm["default"].div(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(1);
});
var CTAButton = (0,styled_components_browser_esm["default"])(esm.Button)(_templateObject1());
var Heading = (0,styled_components_browser_esm["default"])(esm.Typography)(_templateObject2());
var Body = (0,styled_components_browser_esm["default"])(esm.Typography)(_templateObject3());
var StyledButton = (0,styled_components_browser_esm["default"])(esm.Button)(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.spacing(1);
});
var Wrapper = (0,styled_components_browser_esm["default"])(esm.Box)(_templateObject5());
var Title = (0,styled_components_browser_esm["default"])(esm.Typography)(_templateObject6());
var Subtitle = (0,styled_components_browser_esm["default"])(esm.Typography)(_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.spacing(1);
});


/***/ })

}]);